import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  layerBDark,
  layerB,
  scrollbarY,
  layerA,
  justifyContentFlexStart,
} from '../../styles/commonStyles';
import {
  handleAddLocations,
  handleAddMachines,
  handleAddSpecificLocations,
  handleLocationSelect,
  handleMachineSelect,
  handleMachineSelectAlt,
  handleMachineSelectWithSpecLocationAlt,
  handleSelectAll,
  handleSelectedOne,
  handleSpecificLocationSelect,
  selectMasterControls,
} from '../../store/slices/masterControlSelectSlice';

import { handleResetAll } from '../../store/slices/selectedMachinesSlice';
import {
  tesHandleSelectIndividualMachine,
  tesHandleUnSelectIndividualMachine,
  tesSpecificLocationSelectMachinesHandler,
  tesSpecificLocationUnselectMachinesHandler,
} from '../../store/slices/tesSwitchSlice';
import {
  tgsHandleSelectIndividualMachine,
  tgsHandleUnSelectIndividualMachine,
  tgsSpecificLocationSelectMachinesHandler,
  tgsSpecificLocationUnselectMachinesHandler,
} from '../../store/slices/tgsSwitchSlice';

import {
  flexBoxCenter,
  justifyContentFlexEnd,
  justifyContentSpaceBetween,
} from '../../styles/commonStyles';
import {
  essSpecificLocationSelectMachinesHandler,
  essSpecificLocationUnselectMachinesHandler,
  handleSelectIndividualMachine,
  handleUnSelectIndividualMachine,
} from '../../store/slices/essSwitchSlice';
import SelectIndividualOptions from './SelectIndividualOptions';
import SelectionsButton from './SelectionsButton';
import {
  hpEcHandleSelectIndividualMachine,
  hpEcHandleUnSelectIndividualMachine,
} from '../../store/slices/hpElectricSwitchSlice';
import {
  hpGcHandleSelectIndividualMachine,
  hpGcHandleUnSelectIndividualMachine,
} from '../../store/slices/hpGasSwitchSlice';
import {
  tgsDataConsumptionHandleSelectIndividualMachine,
  tgsDataConsumptionHandleUnSelectIndividualMachine,
  tgsDataConsumptionSpecificLocationSelectMachineHandler,
  tgsDataConsumptionSpecificLocationUnselectMachineHandler,
} from '../../store/slices/tgsDataConsumptionSlice';
import {
  tesDataConsumptionHandleSelectIndividualMachine,
  tesDataConsumptionHandleUnSelectIndividualMachine,
  tesDataConsumptionSpecificLocationSelectMachineHandler,
  tesDataConsumptionSpecificLocationUnselectMachineHandler,
} from '../../store/slices/tesDataConsumptionSlice';
import {
  essDataConsumptionHandleSelectIndividualMachine,
  essDataConsumptionHandleUnSelectIndividualMachine,
  essDataConsumptionSpecificLocationSelectMachineHandler,
  essDataConsumptionSpecificLocationUnselectMachineHandler,
} from '../../store/slices/essDataConsumptionSlice';
import {
  hpDataConsumptionHandleSelectIndividualMachine,
  hpDataConsumptionHandleUnSelectIndividualMachine,
} from '../../store/slices/hpDataConsumptionSlice';
import { useSelectSwitchDropBoxDispatches } from '../../../hooks/useSelectSwitchesDispatches';
import {
  coversSelection,
  useSelectSwitchesDisplay,
} from '../../../hooks/useSelectSwitchesDisplay';
import { useSelectBoxArrowsState } from '../../../hooks/useSelectBoxArrowsState';
import { getAllSpecificLocationNames } from '../../../helpers/helpers';

const SelectSwitchMachineOptions = ({
  handleClose,
  data,
  swt,
  isTelemetry,
  selectedDeviceIds,
  setselectedDeviceIds,
  setSelectSpecific
}) => {
  const locations = Object.keys(data);

  const buttons = ['clear', 'apply'];
  const masterControlSelects = useSelector(selectMasterControls);
  const dispatch = useDispatch();

  const [isSelected, setIsSelected] = useState(false);
const [selectedIds, setSelectedIds] = useState([]);
  const [specificLocationsNameList, setSpecificLocationsNameList] = useState(
    []
  );

  const { trackArrowState, trackSpecLocationArrowState, specificLocations } =
    useSelectBoxArrowsState(data);

  const [isArrowDown, setIsArrowDown] = useState(trackArrowState);
  const [isSpecLocationArrowDown, setIsSpecLocationArrowDown] = useState(
    trackSpecLocationArrowState
  );

  const {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedSpecificLocations,
    selectedMachines,
    selectedLocations,
  } =
    swt === 'ess'
      ? masterControlSelects.ess
      : swt === 'tes'
      ? masterControlSelects.tes
      : swt === 'tgs'
      ? masterControlSelects.tgs
      : swt === 'essDc'
      ? masterControlSelects.essDc
      : swt === 'tgsTesDc'
      ? masterControlSelects.tgsTesDc
      : swt === 'hpDc'
      ? masterControlSelects.hpDc
      : swt === 'hpEc'
      ? masterControlSelects.hpEc
      : swt === 'hpGc' && masterControlSelects.hpGc;

  const allSelectBoxData = {
    isAllSelected,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    selectedSpecificLocations,
    selectedMachines,
    selectedLocations,
  };

  useEffect(() => {
    const result = getAllSpecificLocationNames(data);
    setSpecificLocationsNameList(result);
  }, [data]);

  const useHandleSelect = (option, machine, extraOption, machineIndex) => {
    const { selectedList, select, expanded } = useSelectSwitchesDisplay(
      option,
      machine,
      extraOption,
      machineIndex,
      specificLocations,
      swt,
      data,
      allSelectBoxData,
      dispatch
    );

    setIsSelected(select);

    setselectedDeviceIds((prev) => {
      const current = prev || [];

      if (select) {
        return [...current, ...selectedList];
      }

      const kept = current.filter(
        (entry) => !selectedList.some((removed) => coversSelection(removed, entry))
      );

      return [...kept, ...expanded];
    });
  };

  const useHandleOnClick = (button) => {
    useSelectSwitchDropBoxDispatches(
      button,
      allSelectBoxData,
      swt,
      isSelected,
      handleClose,
      data,
      dispatch,
      setSelectSpecific,
      setselectedDeviceIds
    );
  };

  return (
    <>
      {swt && (
        <Wrapper>
          <ScrollBarWrapper>
            <SectionOptions>
              <SelectIndividualOptions
                option='all'
                handleSelect={useHandleSelect}
                isSelected={isAllSelected}
                isTelemetry={isTelemetry}
              />

              {locations.map((location, index) => {
                return (
                  <SelectIndividualOptions
                    key={index}
                    index={index}
                    option={location}
                    data={data[location]}
                    handleSelect={useHandleSelect}
                    isSelected={isLocationSelected[index]}
                    allSpecificLocationsName={specificLocationsNameList}
                    isSpecificLocationSelected={isSpecificLocationSelected}
                    isMachineSelected={
                      isMachineSelected[index] && isMachineSelected[index]
                    }
                    isArrowDown={isArrowDown}
                    setIsArrowDown={setIsArrowDown}
                    isSpecLocationArrowDown={isSpecLocationArrowDown}
                    setIsSpecLocationArrowDown={setIsSpecLocationArrowDown}
                    isTelemetry={isTelemetry}
                  />
                );
              })}
            </SectionOptions>
          </ScrollBarWrapper>
          <SectionButtons>
            <ButtonWrapper>
              {buttons.map((button, index) => (
                <div key={index}>
                  <SelectionsButton
                    title={button}
                    onClickButton={useHandleOnClick}
                    index={index}
                  />
                </div>
              ))}
            </ButtonWrapper>
          </SectionButtons>
        </Wrapper>
      )}
    </>
  );
};

export default SelectSwitchMachineOptions;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 5px;
  ${flexBoxCenter}
  flex-direction: column;
`;

const ScrollBarWrapper = styled.div`
  width: 99.5%;
  min-height: 68px;
  max-height: 184px;
  padding: 4px;
  margin-bottom: 4px;
  border-radius: 14px 8px 8px 14px;
  ${layerBDark}

  ${justifyContentFlexStart}
`;

const SectionOptions = styled.div`
  width: 100%;
  min-height: 60px;
  max-height: 176px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  ${scrollbarY}
`;

const SectionButtons = styled.div`
  width: 98%;
  height: 45px;

  ${justifyContentFlexEnd}
`;

const ButtonWrapper = styled.div`
  width: 174px;
  height: 45px;
  padding-left: 2px;
  padding-right: 2px;

  ${layerB}

  border-radius: 23px;
  opacity: 1;
  z-index: 10;
  ${justifyContentSpaceBetween}
`;
